<template>
	<div class="full-image" v-show="visible" :before-close="onClose" :modal="true">
		<div class="mask"></div>
		<div class="image-box">
			<div v-if="loading" class="loading-spinner">
				<i class="el-icon-loading"></i>
			</div>
			<img :src="url" :key="url" @load="onImageLoad" :style="{ opacity: loading ? 0 : 1 }" />
		</div>
		<!-- 上一张按钮 -->
		<div class="nav-btn prev-btn" @click="onPrev" v-if="hasPrev">
			<i class="el-icon-arrow-left"></i>
		</div>
		<!-- 下一张按钮 -->
		<div class="nav-btn next-btn" @click="onNext" v-if="hasNext">
			<i class="el-icon-arrow-right"></i>
		</div>
		<div class="close" @click="onClose"><i class="el-icon-close"></i></div>
	</div>
</template>

<script>
export default {
	name: "fullImage",
	data() {
		return {
			fit: 'contain',
			enableTransition: false,
			loading: false
		}
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				this.enableTransition = false;
				this.checkLoading(this.url);
			}
		},
		url(val) {
			this.checkLoading(val);
		},
		currentIndex() {
			this.enableTransition = true;
		}
	},
	computed: {
		hasPrev() {
			return this.imageList && this.imageList.length > 1 && this.currentIndex > 0 && this.allowSwitch;
		},
		hasNext() {
			return this.imageList && this.imageList.length > 1 && this.currentIndex < this.imageList.length - 1 && this.allowSwitch;
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		onPrev() {
			if (this.hasPrev) {
				this.$emit("change", this.currentIndex - 1);
			}
		},
		onNext() {
			if (this.hasNext) {
				this.$emit("change", this.currentIndex + 1);
			}
		},
		onImageLoad() {
			this.loading = false;
		},
		checkLoading(url) {
			if (!url) { this.loading = false; return; }
			const img = new Image();
			img.src = url;
			this.loading = !img.complete;
		}
	},
	props: {
		visible: {
			type: Boolean
		},
		url: {
			type: String
		},
		imageList: {
			type: Array,
			default: () => []
		},
		currentIndex: {
			type: Number,
			default: 0
		},
		allowSwitch: {
			type: Boolean,
			default: true
		}
	}
}
</script>

<style lang="scss">
.full-image {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 9999;

	.mask {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.5;
		z-index: 9999;
	}

	.image-box {
		position: relative;
		width: 100%;
		height: 100%;
		z-index: 10000;

		img {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			max-height: 90%;
			max-width: 90%;
			border: 3px solid white;
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
			background: white;
			transition: opacity 0.2s ease;
		}

		.loading-spinner {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			color: white;
			font-size: 36px;
		}
	}

	.close {
		position: fixed;
		top: 10px;
		right: 10px;
		color: white;
		font-size: 25px;
		cursor: pointer;
		z-index: 10001;
		pointer-events: auto;
		transition: transform 0.2s;

		&:hover {
			transform: scale(1.1);
		}
	}

	.nav-btn {
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		color: white;
		font-size: 40px;
		cursor: pointer;
		z-index: 10001;
		pointer-events: auto;
		background: rgba(0, 0, 0, 0.5);
		width: 50px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		transition: all 0.2s;

		&:hover {
			background: rgba(0, 0, 0, 0.8);
			transform: translateY(-50%) scale(1.1);
		}

		&:active {
			transform: translateY(-50%) scale(0.95);
		}
	}

	.prev-btn {
		left: 20px;
	}

	.next-btn {
		right: 20px;
	}
}
</style>
